<template>
  <div class="main" id="media-page">
    <p id="titolo">Emittenti da ascoltare</p>
    <div
      v-on:tap="changeSelected(radio)"
      v-bind:class="{ 'selected': radio.name===selected }"
      class="media-box"
      v-for="radio in stations"
      v-bind:key="radio.name"
    >
      <div class="radio-logo">
        <img v-bind:src="radio.logo" />
      </div>

      <p class="radio-name">{{radio.name}}</p>
    </div>
  </div>
</template>

<script>
import playerService from '../services/Player.service';
const stations = [
  {
    name: 'RDS 100% grandi successi',
    logo: require('../assets/images/Logo.png'),
    streamingUrls: [
      'https://stream.rds.radio/audio/rds.stream_aac/chunklist.m3u8',
      'https://radioisp1.rds.it/mp3'
    ]
  },
  {
    name: 'RDS Next',
    logo: require('../assets/images/loghi-radio/RDS_NEXT.png'),
    streamingUrls: [
      'https://audionext.rds.radio/chunklist.m3u8',
      'https://icstream.rds.radio/next'
    ]
  },
  {
    name: 'RDS Relax',
    logo: require('../assets/images/loghi-radio/RDS_Relax.png'),
    streamingUrls: [
      'https://stream.rds.radio/audio/rdsrelax.stream_aac/chunklist.m3u8',
      'https://icstream.rds.radio/rdsrelax'
    ]
  },
  {
    name: 'Discoradio',
    logo: require('../assets/images/loghi-radio/Discoradio.png'),
    streamingUrls: [
      'https://stream.discoradio.radio/audio/disco.stream_aac/chunklist.m3u8',
      'https://icstream.rds.radio/disco'
    ]
  },
  {
    name: 'Dimensione Suono Soft',
    logo: require('../assets/images/loghi-radio/DSSoft.png'),
    streamingUrls: [
      'https://stream.dimensionesuonosoft.radio/audio/dssc.stream_aac/chunklist.m3u8',
      'https://icstream.rds.radio/dssc'
    ]
  },
  {
    name: 'Ram Power',
    logo: require('../assets/images/loghi-radio/RAM.png'),
    streamingUrls: [
      'https://stream.rampower.radio/audio/ram.stream_aac/chunklist.m3u8',
      'https://icstream.rds.radio/ram'
    ]
  },
  {
    name: 'Dimensione Suono Roma',
    logo: require('../assets/images/loghi-radio/DSR.png'),
    streamingUrls: [
      'https://stream.dimensionesuonoroma.radio/audio/dsr.stream_aac/chunklist.m3u8',
      'https://icstream.rds.radio/dsr'
    ]
  }
];

export default {
  name: 'rds-media',
  data() {
    return {
      stations: stations,
      selected: stations[0].name
    };
  },
  methods: {
    changeSelected(radio) {
      this.selected = radio.name;
      playerService.stationName = radio.name;
      playerService.stationLogo = radio.logo;
      playerService.streamingUrls = radio.streamingUrls;
    }
  }
};
</script>
<style lang="scss" scoped>
#media-page {
  padding: 13px 13px 25px 13px;
}
.media-box {
  background: #fff;
  display: flex;
  align-items: center;
  box-shadow: 0 6pt 12px rgba(0, 0, 0, 0.05);
  margin-bottom: 10px;
  height: 50px;
  border-radius: $default-border-radius;
  padding: 20px 0;
  .radio-logo {
    width: 60px;
    margin: 0 10px;
  }
  img {
    filter: grayscale(100%);
    transition: filter 0.2s, -webkit-filter 0.2s;
  }
  &.selected img {
    filter: grayscale(0%);
  }
}
</style>
